/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SplatRouteImport } from './routes/$'
import { Route as CenteredLayoutRouteRouteImport } from './routes/_centered-layout/route'
import { Route as MainLayoutRouteRouteImport } from './routes/_main-layout/route'
import { Route as AuthRouteRouteImport } from './routes/auth/route'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as SubscriptionRouteRouteImport } from './routes/subscription/route'
import { Route as CenteredLayoutOnboardRouteImport } from './routes/_centered-layout/onboard'
import { Route as CenteredLayoutTokenToLsRouteImport } from './routes/_centered-layout/token-to-ls'
import { Route as MainLayoutListRouteImport } from './routes/_main-layout/list'
import { Route as AuthForgotRouteImport } from './routes/auth/forgot'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as AuthRegisterRouteImport } from './routes/auth/register'
import { Route as AuthResetPasswordRouteImport } from './routes/auth/reset-password'
import { Route as DemoLayoutRouteRouteImport } from './routes/demo/_layout/route'
import { Route as SubscriptionIndexRouteImport } from './routes/subscription/index'
import { Route as MainLayoutCardsIndexRouteImport } from './routes/_main-layout/cards/index'
import { Route as MainLayoutCardsFinishRouteImport } from './routes/_main-layout/cards/finish'
import { Route as MainLayoutCardsNoCardsRouteImport } from './routes/_main-layout/cards/no-cards'
import { Route as MainLayoutCardsNoCardsInStackRouteImport } from './routes/_main-layout/cards/no-cards-in-stack'
import { Route as MainLayoutSettingsIndexRouteImport } from './routes/_main-layout/settings/index'
import { Route as MainLayoutSettingsContactUsRouteImport } from './routes/_main-layout/settings/contact-us'
import { Route as MainLayoutSettingsIosInstallRouteImport } from './routes/_main-layout/settings/ios-install'
import { Route as MainLayoutSettingsLanguagesRouteImport } from './routes/_main-layout/settings/languages'
import { Route as MainLayoutSettingsSnoozeRouteImport } from './routes/_main-layout/settings/snooze'
import { Route as DemoLayoutListRouteImport } from './routes/demo/_layout/list'
import { Route as DemoLayoutSettingsRouteImport } from './routes/demo/_layout/settings'
import { Route as SubscriptionCheckoutIndexRouteImport } from './routes/subscription/checkout/index'
import { Route as SubscriptionCheckoutCompleteRouteImport } from './routes/subscription/checkout/complete'
import { Route as MainLayoutSettingsSubscriptionChangeRouteImport } from './routes/_main-layout/settings/subscription/change'
import { Route as MainLayoutSettingsSubscriptionChangePaymentMethodRouteImport } from './routes/_main-layout/settings/subscription/change-payment-method'
import { Route as MainLayoutSettingsSubscriptionChangePaymentMethodSuccessRouteImport } from './routes/_main-layout/settings/subscription/change-payment-method-success'
import { Route as MainLayoutSettingsSubscriptionUsageRouteImport } from './routes/_main-layout/settings/subscription/usage'
import { Route as DemoLayoutCardsIndexRouteImport } from './routes/demo/_layout/cards/index'
import { Route as DemoLayoutCardsFinishRouteImport } from './routes/demo/_layout/cards/finish'
import { Route as DemoLayoutCardsNoCardsInStackRouteImport } from './routes/demo/_layout/cards/no-cards-in-stack'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const CenteredLayoutRouteRoute = CenteredLayoutRouteRouteImport.update({
  id: '/_centered-layout',
  getParentRoute: () => rootRouteImport,
} as any)
const MainLayoutRouteRoute = MainLayoutRouteRouteImport.update({
  id: '/_main-layout',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const SubscriptionRouteRoute = SubscriptionRouteRouteImport.update({
  id: '/subscription',
  path: '/subscription',
  getParentRoute: () => rootRouteImport,
} as any)
const CenteredLayoutOnboardRoute = CenteredLayoutOnboardRouteImport.update({
  id: '/onboard',
  path: '/onboard',
  getParentRoute: () => CenteredLayoutRouteRoute,
} as any)
const CenteredLayoutTokenToLsRoute = CenteredLayoutTokenToLsRouteImport.update({
  id: '/token-to-ls',
  path: '/token-to-ls',
  getParentRoute: () => CenteredLayoutRouteRoute,
} as any)
const MainLayoutListRoute = MainLayoutListRouteImport.update({
  id: '/list',
  path: '/list',
  getParentRoute: () => MainLayoutRouteRoute,
} as any)
const AuthForgotRoute = AuthForgotRouteImport.update({
  id: '/forgot',
  path: '/forgot',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthRegisterRoute = AuthRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRouteRoute,
} as any)
const DemoLayoutRouteRoute = DemoLayoutRouteRouteImport.update({
  id: '/demo/_layout',
  path: '/demo',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/demo/_layout/route.lazy').then((d) => d.Route),
)
const SubscriptionIndexRoute = SubscriptionIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SubscriptionRouteRoute,
} as any)
const MainLayoutCardsIndexRoute = MainLayoutCardsIndexRouteImport.update({
  id: '/cards/',
  path: '/cards/',
  getParentRoute: () => MainLayoutRouteRoute,
} as any)
const MainLayoutCardsFinishRoute = MainLayoutCardsFinishRouteImport.update({
  id: '/cards/finish',
  path: '/cards/finish',
  getParentRoute: () => MainLayoutRouteRoute,
} as any)
const MainLayoutCardsNoCardsRoute = MainLayoutCardsNoCardsRouteImport.update({
  id: '/cards/no-cards',
  path: '/cards/no-cards',
  getParentRoute: () => MainLayoutRouteRoute,
} as any)
const MainLayoutCardsNoCardsInStackRoute =
  MainLayoutCardsNoCardsInStackRouteImport.update({
    id: '/cards/no-cards-in-stack',
    path: '/cards/no-cards-in-stack',
    getParentRoute: () => MainLayoutRouteRoute,
  } as any)
const MainLayoutSettingsIndexRoute = MainLayoutSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => MainLayoutRouteRoute,
} as any)
const MainLayoutSettingsContactUsRoute =
  MainLayoutSettingsContactUsRouteImport.update({
    id: '/settings/contact-us',
    path: '/settings/contact-us',
    getParentRoute: () => MainLayoutRouteRoute,
  } as any)
const MainLayoutSettingsIosInstallRoute =
  MainLayoutSettingsIosInstallRouteImport.update({
    id: '/settings/ios-install',
    path: '/settings/ios-install',
    getParentRoute: () => MainLayoutRouteRoute,
  } as any)
const MainLayoutSettingsLanguagesRoute =
  MainLayoutSettingsLanguagesRouteImport.update({
    id: '/settings/languages',
    path: '/settings/languages',
    getParentRoute: () => MainLayoutRouteRoute,
  } as any)
const MainLayoutSettingsSnoozeRoute =
  MainLayoutSettingsSnoozeRouteImport.update({
    id: '/settings/snooze',
    path: '/settings/snooze',
    getParentRoute: () => MainLayoutRouteRoute,
  } as any)
const DemoLayoutListRoute = DemoLayoutListRouteImport.update({
  id: '/list',
  path: '/list',
  getParentRoute: () => DemoLayoutRouteRoute,
} as any)
const DemoLayoutSettingsRoute = DemoLayoutSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => DemoLayoutRouteRoute,
} as any)
const SubscriptionCheckoutIndexRoute =
  SubscriptionCheckoutIndexRouteImport.update({
    id: '/checkout/',
    path: '/checkout/',
    getParentRoute: () => SubscriptionRouteRoute,
  } as any)
const SubscriptionCheckoutCompleteRoute =
  SubscriptionCheckoutCompleteRouteImport.update({
    id: '/checkout/complete',
    path: '/checkout/complete',
    getParentRoute: () => SubscriptionRouteRoute,
  } as any)
const MainLayoutSettingsSubscriptionChangeRoute =
  MainLayoutSettingsSubscriptionChangeRouteImport.update({
    id: '/settings/subscription/change',
    path: '/settings/subscription/change',
    getParentRoute: () => MainLayoutRouteRoute,
  } as any)
const MainLayoutSettingsSubscriptionChangePaymentMethodRoute =
  MainLayoutSettingsSubscriptionChangePaymentMethodRouteImport.update({
    id: '/settings/subscription/change-payment-method',
    path: '/settings/subscription/change-payment-method',
    getParentRoute: () => MainLayoutRouteRoute,
  } as any)
const MainLayoutSettingsSubscriptionChangePaymentMethodSuccessRoute =
  MainLayoutSettingsSubscriptionChangePaymentMethodSuccessRouteImport.update({
    id: '/settings/subscription/change-payment-method-success',
    path: '/settings/subscription/change-payment-method-success',
    getParentRoute: () => MainLayoutRouteRoute,
  } as any)
const MainLayoutSettingsSubscriptionUsageRoute =
  MainLayoutSettingsSubscriptionUsageRouteImport.update({
    id: '/settings/subscription/usage',
    path: '/settings/subscription/usage',
    getParentRoute: () => MainLayoutRouteRoute,
  } as any)
const DemoLayoutCardsIndexRoute = DemoLayoutCardsIndexRouteImport.update({
  id: '/cards/',
  path: '/cards/',
  getParentRoute: () => DemoLayoutRouteRoute,
} as any)
const DemoLayoutCardsFinishRoute = DemoLayoutCardsFinishRouteImport.update({
  id: '/cards/finish',
  path: '/cards/finish',
  getParentRoute: () => DemoLayoutRouteRoute,
} as any)
const DemoLayoutCardsNoCardsInStackRoute =
  DemoLayoutCardsNoCardsInStackRouteImport.update({
    id: '/cards/no-cards-in-stack',
    path: '/cards/no-cards-in-stack',
    getParentRoute: () => DemoLayoutRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/auth': typeof AuthRouteRouteWithChildren
  '/subscription': typeof SubscriptionRouteRouteWithChildren
  '/$': typeof SplatRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/demo': typeof DemoLayoutRouteRouteWithChildren
  '/onboard': typeof CenteredLayoutOnboardRoute
  '/token-to-ls': typeof CenteredLayoutTokenToLsRoute
  '/list': typeof MainLayoutListRoute
  '/auth/forgot': typeof AuthForgotRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/register': typeof AuthRegisterRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/subscription/': typeof SubscriptionIndexRoute
  '/cards/finish': typeof MainLayoutCardsFinishRoute
  '/cards/no-cards': typeof MainLayoutCardsNoCardsRoute
  '/cards/no-cards-in-stack': typeof MainLayoutCardsNoCardsInStackRoute
  '/settings/contact-us': typeof MainLayoutSettingsContactUsRoute
  '/settings/ios-install': typeof MainLayoutSettingsIosInstallRoute
  '/settings/languages': typeof MainLayoutSettingsLanguagesRoute
  '/settings/snooze': typeof MainLayoutSettingsSnoozeRoute
  '/demo/list': typeof DemoLayoutListRoute
  '/demo/settings': typeof DemoLayoutSettingsRoute
  '/subscription/checkout/complete': typeof SubscriptionCheckoutCompleteRoute
  '/cards/': typeof MainLayoutCardsIndexRoute
  '/settings/': typeof MainLayoutSettingsIndexRoute
  '/subscription/checkout/': typeof SubscriptionCheckoutIndexRoute
  '/settings/subscription/change': typeof MainLayoutSettingsSubscriptionChangeRoute
  '/settings/subscription/change-payment-method': typeof MainLayoutSettingsSubscriptionChangePaymentMethodRoute
  '/settings/subscription/change-payment-method-success': typeof MainLayoutSettingsSubscriptionChangePaymentMethodSuccessRoute
  '/settings/subscription/usage': typeof MainLayoutSettingsSubscriptionUsageRoute
  '/demo/cards/finish': typeof DemoLayoutCardsFinishRoute
  '/demo/cards/no-cards-in-stack': typeof DemoLayoutCardsNoCardsInStackRoute
  '/demo/cards/': typeof DemoLayoutCardsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth': typeof AuthRouteRouteWithChildren
  '/$': typeof SplatRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/demo': typeof DemoLayoutRouteRouteWithChildren
  '/onboard': typeof CenteredLayoutOnboardRoute
  '/token-to-ls': typeof CenteredLayoutTokenToLsRoute
  '/list': typeof MainLayoutListRoute
  '/auth/forgot': typeof AuthForgotRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/register': typeof AuthRegisterRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/subscription': typeof SubscriptionIndexRoute
  '/cards/finish': typeof MainLayoutCardsFinishRoute
  '/cards/no-cards': typeof MainLayoutCardsNoCardsRoute
  '/cards/no-cards-in-stack': typeof MainLayoutCardsNoCardsInStackRoute
  '/settings/contact-us': typeof MainLayoutSettingsContactUsRoute
  '/settings/ios-install': typeof MainLayoutSettingsIosInstallRoute
  '/settings/languages': typeof MainLayoutSettingsLanguagesRoute
  '/settings/snooze': typeof MainLayoutSettingsSnoozeRoute
  '/demo/list': typeof DemoLayoutListRoute
  '/demo/settings': typeof DemoLayoutSettingsRoute
  '/subscription/checkout/complete': typeof SubscriptionCheckoutCompleteRoute
  '/cards': typeof MainLayoutCardsIndexRoute
  '/settings': typeof MainLayoutSettingsIndexRoute
  '/subscription/checkout': typeof SubscriptionCheckoutIndexRoute
  '/settings/subscription/change': typeof MainLayoutSettingsSubscriptionChangeRoute
  '/settings/subscription/change-payment-method': typeof MainLayoutSettingsSubscriptionChangePaymentMethodRoute
  '/settings/subscription/change-payment-method-success': typeof MainLayoutSettingsSubscriptionChangePaymentMethodSuccessRoute
  '/settings/subscription/usage': typeof MainLayoutSettingsSubscriptionUsageRoute
  '/demo/cards/finish': typeof DemoLayoutCardsFinishRoute
  '/demo/cards/no-cards-in-stack': typeof DemoLayoutCardsNoCardsInStackRoute
  '/demo/cards': typeof DemoLayoutCardsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_centered-layout': typeof CenteredLayoutRouteRouteWithChildren
  '/_main-layout': typeof MainLayoutRouteRouteWithChildren
  '/auth': typeof AuthRouteRouteWithChildren
  '/subscription': typeof SubscriptionRouteRouteWithChildren
  '/$': typeof SplatRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/demo/_layout': typeof DemoLayoutRouteRouteWithChildren
  '/_centered-layout/onboard': typeof CenteredLayoutOnboardRoute
  '/_centered-layout/token-to-ls': typeof CenteredLayoutTokenToLsRoute
  '/_main-layout/list': typeof MainLayoutListRoute
  '/auth/forgot': typeof AuthForgotRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/register': typeof AuthRegisterRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/subscription/': typeof SubscriptionIndexRoute
  '/_main-layout/cards/finish': typeof MainLayoutCardsFinishRoute
  '/_main-layout/cards/no-cards': typeof MainLayoutCardsNoCardsRoute
  '/_main-layout/cards/no-cards-in-stack': typeof MainLayoutCardsNoCardsInStackRoute
  '/_main-layout/settings/contact-us': typeof MainLayoutSettingsContactUsRoute
  '/_main-layout/settings/ios-install': typeof MainLayoutSettingsIosInstallRoute
  '/_main-layout/settings/languages': typeof MainLayoutSettingsLanguagesRoute
  '/_main-layout/settings/snooze': typeof MainLayoutSettingsSnoozeRoute
  '/demo/_layout/list': typeof DemoLayoutListRoute
  '/demo/_layout/settings': typeof DemoLayoutSettingsRoute
  '/subscription/checkout/complete': typeof SubscriptionCheckoutCompleteRoute
  '/_main-layout/cards/': typeof MainLayoutCardsIndexRoute
  '/_main-layout/settings/': typeof MainLayoutSettingsIndexRoute
  '/subscription/checkout/': typeof SubscriptionCheckoutIndexRoute
  '/_main-layout/settings/subscription/change': typeof MainLayoutSettingsSubscriptionChangeRoute
  '/_main-layout/settings/subscription/change-payment-method': typeof MainLayoutSettingsSubscriptionChangePaymentMethodRoute
  '/_main-layout/settings/subscription/change-payment-method-success': typeof MainLayoutSettingsSubscriptionChangePaymentMethodSuccessRoute
  '/_main-layout/settings/subscription/usage': typeof MainLayoutSettingsSubscriptionUsageRoute
  '/demo/_layout/cards/finish': typeof DemoLayoutCardsFinishRoute
  '/demo/_layout/cards/no-cards-in-stack': typeof DemoLayoutCardsNoCardsInStackRoute
  '/demo/_layout/cards/': typeof DemoLayoutCardsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth'
    | '/subscription'
    | '/$'
    | '/privacy-policy'
    | '/demo'
    | '/onboard'
    | '/token-to-ls'
    | '/list'
    | '/auth/forgot'
    | '/auth/login'
    | '/auth/register'
    | '/auth/reset-password'
    | '/subscription/'
    | '/cards/finish'
    | '/cards/no-cards'
    | '/cards/no-cards-in-stack'
    | '/settings/contact-us'
    | '/settings/ios-install'
    | '/settings/languages'
    | '/settings/snooze'
    | '/demo/list'
    | '/demo/settings'
    | '/subscription/checkout/complete'
    | '/cards/'
    | '/settings/'
    | '/subscription/checkout/'
    | '/settings/subscription/change'
    | '/settings/subscription/change-payment-method'
    | '/settings/subscription/change-payment-method-success'
    | '/settings/subscription/usage'
    | '/demo/cards/finish'
    | '/demo/cards/no-cards-in-stack'
    | '/demo/cards/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth'
    | '/$'
    | '/privacy-policy'
    | '/demo'
    | '/onboard'
    | '/token-to-ls'
    | '/list'
    | '/auth/forgot'
    | '/auth/login'
    | '/auth/register'
    | '/auth/reset-password'
    | '/subscription'
    | '/cards/finish'
    | '/cards/no-cards'
    | '/cards/no-cards-in-stack'
    | '/settings/contact-us'
    | '/settings/ios-install'
    | '/settings/languages'
    | '/settings/snooze'
    | '/demo/list'
    | '/demo/settings'
    | '/subscription/checkout/complete'
    | '/cards'
    | '/settings'
    | '/subscription/checkout'
    | '/settings/subscription/change'
    | '/settings/subscription/change-payment-method'
    | '/settings/subscription/change-payment-method-success'
    | '/settings/subscription/usage'
    | '/demo/cards/finish'
    | '/demo/cards/no-cards-in-stack'
    | '/demo/cards'
  id:
    | '__root__'
    | '/'
    | '/_centered-layout'
    | '/_main-layout'
    | '/auth'
    | '/subscription'
    | '/$'
    | '/privacy-policy'
    | '/demo/_layout'
    | '/_centered-layout/onboard'
    | '/_centered-layout/token-to-ls'
    | '/_main-layout/list'
    | '/auth/forgot'
    | '/auth/login'
    | '/auth/register'
    | '/auth/reset-password'
    | '/subscription/'
    | '/_main-layout/cards/finish'
    | '/_main-layout/cards/no-cards'
    | '/_main-layout/cards/no-cards-in-stack'
    | '/_main-layout/settings/contact-us'
    | '/_main-layout/settings/ios-install'
    | '/_main-layout/settings/languages'
    | '/_main-layout/settings/snooze'
    | '/demo/_layout/list'
    | '/demo/_layout/settings'
    | '/subscription/checkout/complete'
    | '/_main-layout/cards/'
    | '/_main-layout/settings/'
    | '/subscription/checkout/'
    | '/_main-layout/settings/subscription/change'
    | '/_main-layout/settings/subscription/change-payment-method'
    | '/_main-layout/settings/subscription/change-payment-method-success'
    | '/_main-layout/settings/subscription/usage'
    | '/demo/_layout/cards/finish'
    | '/demo/_layout/cards/no-cards-in-stack'
    | '/demo/_layout/cards/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CenteredLayoutRouteRoute: typeof CenteredLayoutRouteRouteWithChildren
  MainLayoutRouteRoute: typeof MainLayoutRouteRouteWithChildren
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  SubscriptionRouteRoute: typeof SubscriptionRouteRouteWithChildren
  SplatRoute: typeof SplatRoute
  PrivacyPolicyRoute: typeof PrivacyPolicyRoute
  DemoLayoutRouteRoute: typeof DemoLayoutRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_centered-layout': {
      id: '/_centered-layout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof CenteredLayoutRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_main-layout': {
      id: '/_main-layout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof MainLayoutRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy-policy': {
      id: '/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PrivacyPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/subscription': {
      id: '/subscription'
      path: '/subscription'
      fullPath: '/subscription'
      preLoaderRoute: typeof SubscriptionRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_centered-layout/onboard': {
      id: '/_centered-layout/onboard'
      path: '/onboard'
      fullPath: '/onboard'
      preLoaderRoute: typeof CenteredLayoutOnboardRouteImport
      parentRoute: typeof CenteredLayoutRouteRoute
    }
    '/_centered-layout/token-to-ls': {
      id: '/_centered-layout/token-to-ls'
      path: '/token-to-ls'
      fullPath: '/token-to-ls'
      preLoaderRoute: typeof CenteredLayoutTokenToLsRouteImport
      parentRoute: typeof CenteredLayoutRouteRoute
    }
    '/_main-layout/list': {
      id: '/_main-layout/list'
      path: '/list'
      fullPath: '/list'
      preLoaderRoute: typeof MainLayoutListRouteImport
      parentRoute: typeof MainLayoutRouteRoute
    }
    '/auth/forgot': {
      id: '/auth/forgot'
      path: '/forgot'
      fullPath: '/auth/forgot'
      preLoaderRoute: typeof AuthForgotRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/register': {
      id: '/auth/register'
      path: '/register'
      fullPath: '/auth/register'
      preLoaderRoute: typeof AuthRegisterRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/reset-password': {
      id: '/auth/reset-password'
      path: '/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/demo/_layout': {
      id: '/demo/_layout'
      path: '/demo'
      fullPath: '/demo'
      preLoaderRoute: typeof DemoLayoutRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/subscription/': {
      id: '/subscription/'
      path: '/'
      fullPath: '/subscription/'
      preLoaderRoute: typeof SubscriptionIndexRouteImport
      parentRoute: typeof SubscriptionRouteRoute
    }
    '/_main-layout/cards/': {
      id: '/_main-layout/cards/'
      path: '/cards'
      fullPath: '/cards/'
      preLoaderRoute: typeof MainLayoutCardsIndexRouteImport
      parentRoute: typeof MainLayoutRouteRoute
    }
    '/_main-layout/cards/finish': {
      id: '/_main-layout/cards/finish'
      path: '/cards/finish'
      fullPath: '/cards/finish'
      preLoaderRoute: typeof MainLayoutCardsFinishRouteImport
      parentRoute: typeof MainLayoutRouteRoute
    }
    '/_main-layout/cards/no-cards': {
      id: '/_main-layout/cards/no-cards'
      path: '/cards/no-cards'
      fullPath: '/cards/no-cards'
      preLoaderRoute: typeof MainLayoutCardsNoCardsRouteImport
      parentRoute: typeof MainLayoutRouteRoute
    }
    '/_main-layout/cards/no-cards-in-stack': {
      id: '/_main-layout/cards/no-cards-in-stack'
      path: '/cards/no-cards-in-stack'
      fullPath: '/cards/no-cards-in-stack'
      preLoaderRoute: typeof MainLayoutCardsNoCardsInStackRouteImport
      parentRoute: typeof MainLayoutRouteRoute
    }
    '/_main-layout/settings/': {
      id: '/_main-layout/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof MainLayoutSettingsIndexRouteImport
      parentRoute: typeof MainLayoutRouteRoute
    }
    '/_main-layout/settings/contact-us': {
      id: '/_main-layout/settings/contact-us'
      path: '/settings/contact-us'
      fullPath: '/settings/contact-us'
      preLoaderRoute: typeof MainLayoutSettingsContactUsRouteImport
      parentRoute: typeof MainLayoutRouteRoute
    }
    '/_main-layout/settings/ios-install': {
      id: '/_main-layout/settings/ios-install'
      path: '/settings/ios-install'
      fullPath: '/settings/ios-install'
      preLoaderRoute: typeof MainLayoutSettingsIosInstallRouteImport
      parentRoute: typeof MainLayoutRouteRoute
    }
    '/_main-layout/settings/languages': {
      id: '/_main-layout/settings/languages'
      path: '/settings/languages'
      fullPath: '/settings/languages'
      preLoaderRoute: typeof MainLayoutSettingsLanguagesRouteImport
      parentRoute: typeof MainLayoutRouteRoute
    }
    '/_main-layout/settings/snooze': {
      id: '/_main-layout/settings/snooze'
      path: '/settings/snooze'
      fullPath: '/settings/snooze'
      preLoaderRoute: typeof MainLayoutSettingsSnoozeRouteImport
      parentRoute: typeof MainLayoutRouteRoute
    }
    '/demo/_layout/list': {
      id: '/demo/_layout/list'
      path: '/list'
      fullPath: '/demo/list'
      preLoaderRoute: typeof DemoLayoutListRouteImport
      parentRoute: typeof DemoLayoutRouteRoute
    }
    '/demo/_layout/settings': {
      id: '/demo/_layout/settings'
      path: '/settings'
      fullPath: '/demo/settings'
      preLoaderRoute: typeof DemoLayoutSettingsRouteImport
      parentRoute: typeof DemoLayoutRouteRoute
    }
    '/subscription/checkout/': {
      id: '/subscription/checkout/'
      path: '/checkout'
      fullPath: '/subscription/checkout/'
      preLoaderRoute: typeof SubscriptionCheckoutIndexRouteImport
      parentRoute: typeof SubscriptionRouteRoute
    }
    '/subscription/checkout/complete': {
      id: '/subscription/checkout/complete'
      path: '/checkout/complete'
      fullPath: '/subscription/checkout/complete'
      preLoaderRoute: typeof SubscriptionCheckoutCompleteRouteImport
      parentRoute: typeof SubscriptionRouteRoute
    }
    '/_main-layout/settings/subscription/change': {
      id: '/_main-layout/settings/subscription/change'
      path: '/settings/subscription/change'
      fullPath: '/settings/subscription/change'
      preLoaderRoute: typeof MainLayoutSettingsSubscriptionChangeRouteImport
      parentRoute: typeof MainLayoutRouteRoute
    }
    '/_main-layout/settings/subscription/change-payment-method': {
      id: '/_main-layout/settings/subscription/change-payment-method'
      path: '/settings/subscription/change-payment-method'
      fullPath: '/settings/subscription/change-payment-method'
      preLoaderRoute: typeof MainLayoutSettingsSubscriptionChangePaymentMethodRouteImport
      parentRoute: typeof MainLayoutRouteRoute
    }
    '/_main-layout/settings/subscription/change-payment-method-success': {
      id: '/_main-layout/settings/subscription/change-payment-method-success'
      path: '/settings/subscription/change-payment-method-success'
      fullPath: '/settings/subscription/change-payment-method-success'
      preLoaderRoute: typeof MainLayoutSettingsSubscriptionChangePaymentMethodSuccessRouteImport
      parentRoute: typeof MainLayoutRouteRoute
    }
    '/_main-layout/settings/subscription/usage': {
      id: '/_main-layout/settings/subscription/usage'
      path: '/settings/subscription/usage'
      fullPath: '/settings/subscription/usage'
      preLoaderRoute: typeof MainLayoutSettingsSubscriptionUsageRouteImport
      parentRoute: typeof MainLayoutRouteRoute
    }
    '/demo/_layout/cards/': {
      id: '/demo/_layout/cards/'
      path: '/cards'
      fullPath: '/demo/cards/'
      preLoaderRoute: typeof DemoLayoutCardsIndexRouteImport
      parentRoute: typeof DemoLayoutRouteRoute
    }
    '/demo/_layout/cards/finish': {
      id: '/demo/_layout/cards/finish'
      path: '/cards/finish'
      fullPath: '/demo/cards/finish'
      preLoaderRoute: typeof DemoLayoutCardsFinishRouteImport
      parentRoute: typeof DemoLayoutRouteRoute
    }
    '/demo/_layout/cards/no-cards-in-stack': {
      id: '/demo/_layout/cards/no-cards-in-stack'
      path: '/cards/no-cards-in-stack'
      fullPath: '/demo/cards/no-cards-in-stack'
      preLoaderRoute: typeof DemoLayoutCardsNoCardsInStackRouteImport
      parentRoute: typeof DemoLayoutRouteRoute
    }
  }
}

interface CenteredLayoutRouteRouteChildren {
  CenteredLayoutOnboardRoute: typeof CenteredLayoutOnboardRoute
  CenteredLayoutTokenToLsRoute: typeof CenteredLayoutTokenToLsRoute
}

const CenteredLayoutRouteRouteChildren: CenteredLayoutRouteRouteChildren = {
  CenteredLayoutOnboardRoute: CenteredLayoutOnboardRoute,
  CenteredLayoutTokenToLsRoute: CenteredLayoutTokenToLsRoute,
}

const CenteredLayoutRouteRouteWithChildren =
  CenteredLayoutRouteRoute._addFileChildren(CenteredLayoutRouteRouteChildren)

interface MainLayoutRouteRouteChildren {
  MainLayoutListRoute: typeof MainLayoutListRoute
  MainLayoutCardsFinishRoute: typeof MainLayoutCardsFinishRoute
  MainLayoutCardsNoCardsRoute: typeof MainLayoutCardsNoCardsRoute
  MainLayoutCardsNoCardsInStackRoute: typeof MainLayoutCardsNoCardsInStackRoute
  MainLayoutSettingsContactUsRoute: typeof MainLayoutSettingsContactUsRoute
  MainLayoutSettingsIosInstallRoute: typeof MainLayoutSettingsIosInstallRoute
  MainLayoutSettingsLanguagesRoute: typeof MainLayoutSettingsLanguagesRoute
  MainLayoutSettingsSnoozeRoute: typeof MainLayoutSettingsSnoozeRoute
  MainLayoutCardsIndexRoute: typeof MainLayoutCardsIndexRoute
  MainLayoutSettingsIndexRoute: typeof MainLayoutSettingsIndexRoute
  MainLayoutSettingsSubscriptionChangeRoute: typeof MainLayoutSettingsSubscriptionChangeRoute
  MainLayoutSettingsSubscriptionChangePaymentMethodRoute: typeof MainLayoutSettingsSubscriptionChangePaymentMethodRoute
  MainLayoutSettingsSubscriptionChangePaymentMethodSuccessRoute: typeof MainLayoutSettingsSubscriptionChangePaymentMethodSuccessRoute
  MainLayoutSettingsSubscriptionUsageRoute: typeof MainLayoutSettingsSubscriptionUsageRoute
}

const MainLayoutRouteRouteChildren: MainLayoutRouteRouteChildren = {
  MainLayoutListRoute: MainLayoutListRoute,
  MainLayoutCardsFinishRoute: MainLayoutCardsFinishRoute,
  MainLayoutCardsNoCardsRoute: MainLayoutCardsNoCardsRoute,
  MainLayoutCardsNoCardsInStackRoute: MainLayoutCardsNoCardsInStackRoute,
  MainLayoutSettingsContactUsRoute: MainLayoutSettingsContactUsRoute,
  MainLayoutSettingsIosInstallRoute: MainLayoutSettingsIosInstallRoute,
  MainLayoutSettingsLanguagesRoute: MainLayoutSettingsLanguagesRoute,
  MainLayoutSettingsSnoozeRoute: MainLayoutSettingsSnoozeRoute,
  MainLayoutCardsIndexRoute: MainLayoutCardsIndexRoute,
  MainLayoutSettingsIndexRoute: MainLayoutSettingsIndexRoute,
  MainLayoutSettingsSubscriptionChangeRoute:
    MainLayoutSettingsSubscriptionChangeRoute,
  MainLayoutSettingsSubscriptionChangePaymentMethodRoute:
    MainLayoutSettingsSubscriptionChangePaymentMethodRoute,
  MainLayoutSettingsSubscriptionChangePaymentMethodSuccessRoute:
    MainLayoutSettingsSubscriptionChangePaymentMethodSuccessRoute,
  MainLayoutSettingsSubscriptionUsageRoute:
    MainLayoutSettingsSubscriptionUsageRoute,
}

const MainLayoutRouteRouteWithChildren = MainLayoutRouteRoute._addFileChildren(
  MainLayoutRouteRouteChildren,
)

interface AuthRouteRouteChildren {
  AuthForgotRoute: typeof AuthForgotRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthRegisterRoute: typeof AuthRegisterRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthForgotRoute: AuthForgotRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthRegisterRoute: AuthRegisterRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

interface SubscriptionRouteRouteChildren {
  SubscriptionIndexRoute: typeof SubscriptionIndexRoute
  SubscriptionCheckoutCompleteRoute: typeof SubscriptionCheckoutCompleteRoute
  SubscriptionCheckoutIndexRoute: typeof SubscriptionCheckoutIndexRoute
}

const SubscriptionRouteRouteChildren: SubscriptionRouteRouteChildren = {
  SubscriptionIndexRoute: SubscriptionIndexRoute,
  SubscriptionCheckoutCompleteRoute: SubscriptionCheckoutCompleteRoute,
  SubscriptionCheckoutIndexRoute: SubscriptionCheckoutIndexRoute,
}

const SubscriptionRouteRouteWithChildren =
  SubscriptionRouteRoute._addFileChildren(SubscriptionRouteRouteChildren)

interface DemoLayoutRouteRouteChildren {
  DemoLayoutListRoute: typeof DemoLayoutListRoute
  DemoLayoutSettingsRoute: typeof DemoLayoutSettingsRoute
  DemoLayoutCardsFinishRoute: typeof DemoLayoutCardsFinishRoute
  DemoLayoutCardsNoCardsInStackRoute: typeof DemoLayoutCardsNoCardsInStackRoute
  DemoLayoutCardsIndexRoute: typeof DemoLayoutCardsIndexRoute
}

const DemoLayoutRouteRouteChildren: DemoLayoutRouteRouteChildren = {
  DemoLayoutListRoute: DemoLayoutListRoute,
  DemoLayoutSettingsRoute: DemoLayoutSettingsRoute,
  DemoLayoutCardsFinishRoute: DemoLayoutCardsFinishRoute,
  DemoLayoutCardsNoCardsInStackRoute: DemoLayoutCardsNoCardsInStackRoute,
  DemoLayoutCardsIndexRoute: DemoLayoutCardsIndexRoute,
}

const DemoLayoutRouteRouteWithChildren = DemoLayoutRouteRoute._addFileChildren(
  DemoLayoutRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CenteredLayoutRouteRoute: CenteredLayoutRouteRouteWithChildren,
  MainLayoutRouteRoute: MainLayoutRouteRouteWithChildren,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  SubscriptionRouteRoute: SubscriptionRouteRouteWithChildren,
  SplatRoute: SplatRoute,
  PrivacyPolicyRoute: PrivacyPolicyRoute,
  DemoLayoutRouteRoute: DemoLayoutRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
